// extracted by mini-css-extract-plugin
export var cardSelected = "_ig-2";
export var image = "_ig-1";
export var table = "_ig-0";